import { render, staticRenderFns } from "./umkmupload.vue?vue&type=template&id=1691f906&scoped=true&"
var script = {}
import style0 from "./umkmupload.vue?vue&type=style&index=0&id=1691f906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1691f906",
  null
  
)

export default component.exports